/**
 * Meow, The Cat Pet — an animated cat that wanders the page
 *
 * Exposes broad globs — `images/*.png`, `images/*.json`, `js/*.json`, `js/*.atlas`,
 * `sound/*.mp3` and more — to <all_urls> with no `use_dynamic_url`, so every bundled
 * asset resolves from any page at a fixed URL. The item icons under `images/icons/` and
 * the spine animation data under `js/spine/` are stable vendor paths.
 *
 * A coin icon is the cleanest signal: an image loaded via `probeImage` with no CORS
 * grant, served only when the extension is installed.
 *
 * Manifest verified against version 2.0.1.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ejgnolahdlcimijhloboakpjogbfdkkp';

export const meowTheCatPet: ExtensionDefinition = {
  id: ID,
  name: 'Meow, The Cat Pet',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 70_000,
  notes:
    'Broad WAR globs (images/*, js/*.json, sound/*.mp3) on <all_urls> with no dynamic ' +
    'URL. Detection via a stable asset path is conclusive and CORS-free.',
  signals: [
    {
      id: 'war-coin-icon-image',
      kind: 'web-accessible-resource',
      description:
        'Load images/icons/coin.png via <img> — exposed to every origin and readable ' +
        'without a CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/icons/coin.png'),
    },
    {
      id: 'war-cat-spine-json',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/spine/cat.json — the cat spine-animation data, a distinctive path ' +
        'independent of the icons.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/spine/cat.json'),
    },
  ],
};
